import { createFileRoute } from "@tanstack/react-router";
import { chefQueries } from "@/domain/chef/chef.query";
import { createSEOHead, SEO_DATA } from "@/lib/seo";
import { LandingHero } from "@/components/landing/LandingHero";
import { CustomRequestSteps } from "@/components/landing/CustomRequestSteps";
import { ChefAroundCity } from "@/components/landing/ChefAroundCity";
import { Benefits } from "@/components/landing/Benefits";
import { CustomRequestCta } from "@/components/layouts/CustomRequestCta";
import { ChefOnboarding } from "@/components/landing/ChefOnboarding";
import { Reviews } from "@/components/landing/Reviews";
import { Newsletter } from "@/components/landing/Newsletter";
import { Faq } from "@/components/layouts/Faq";

export const Route = createFileRoute("/(public)/")({
  head: () => createSEOHead(SEO_DATA.HOME),
  loader: ({ context: { queryClient } }) => {
    return queryClient.ensureQueryData(chefQueries.aroundCity()).catch(() => null);
  },
  component: Index,
});

function Index() {
  return (
    <main>
      {/* 1. Hero — CTA "demande personnalisée" en priorité absolue */}
      <LandingHero />

      {/* 2. Comment ça marche — explication du flux sur mesure en 3 étapes */}
      <CustomRequestSteps />

      {/* 3. Avis clients — preuve sociale pour rassurer avant d'agir */}
      <Reviews />

      {/* 4. Nos chefs — browsing en option secondaire */}
      <div className="bg-dark-blue rounded-lg margin-top">
        <ChefAroundCity />
      </div>

      {/* 5. Comparaison avantages Hometoq */}
      <Benefits />

      {/* 6. Second CTA demande personnalisée — rappel pour ceux qui scrollent */}
      <div className="mx-auto margin-top max-md:max-w-[95%]">
        <CustomRequestCta />
      </div>

      {/* 7. Devenir chef */}
      <ChefOnboarding />

      {/* 8. Newsletter + FAQ */}
      <Newsletter />
      <Faq />
    </main>
  );
}
